import { useQuery } from '@tanstack/react-query';
import { ProfileServices } from '../services/ProfileServices';
import { USER_PROFILE_QUERY_KEY } from '../constants/Constant';
import {
  QUERY_GC_TIME_LONG_MS,
  QUERY_STALE_TIME_MS,
} from 'constants/appConstants';

export const useFetchUserProfile = () => {
  return useQuery({
    queryKey: [USER_PROFILE_QUERY_KEY],
    queryFn: () => ProfileServices.GetUser(),
    staleTime: QUERY_STALE_TIME_MS,
    gcTime: QUERY_GC_TIME_LONG_MS,
  });
};

export default useFetchUserProfile;
